export default {
  data() {
    return {
      pTopDesktop: 89,
      pBottomDesktop: 89,

      pTopTablet: 89,
      pBottomTablet: 89,

      pTopMobile: 55,
      pBottomMobile: 55
    };
  },
  computed: {
    paddingCalculator() {
      return {
        "padding-top":
          this.currentPaddingDevice(true) +
          Math.round(
            (this.currentPaddingDevice(true) *
              (_.get(this.contentData, "conf.paddingTop")
                ? parseFloat(_.get(this.contentData, "conf.paddingTop"))
                : 0)) /
              100
          ) +
          "px",
        "padding-bottom":
          this.currentPaddingDevice(false) +
          Math.round(
            (this.currentPaddingDevice(false) *
              (_.get(this.contentData, "conf.paddingBottom")
                ? parseFloat(_.get(this.contentData, "conf.paddingBottom"))
                : 0)) /
              100
          ) +
          "px"
      };
    }
  },
  methods: {
    currentPaddingDevice(isTop) {
      if (this.$mq === "phone") {
        return isTop ? this.pTopMobile : this.pBottomMobile;
      }
      if (this.$mq === "tablet") {
        return isTop ? this.pTopTablet : this.pBottomTablet;
      } else {
        return isTop ? this.pTopDesktop : this.pBottomDesktop;
      }
    }
  }
};
